import { useQueries } from '@tanstack/react-query';
import api from '../../../api/api';
import { useUserStore } from '../../../stores/userStore';
import { recordEndpoints, unwrapRecords } from './myRecordsModel';
const resources = Object.keys(recordEndpoints);
export default function useMyRecords(profile) {
  const user = useUserStore((state) => state.user);
  const enabled = user?.id != null && String(user.id) === String(profile.id);
  const queries = useQueries({
    queries: resources.map((resource) => ({
      queryKey: ['myMusicRecords', user?.id, resource],
      queryFn: async ({ signal }) =>
        unwrapRecords(await api.getAuth(recordEndpoints[resource], { signal })),
      enabled,
      retry: false,
      gcTime: 0,
      staleTime: 0,
    })),
  });
  // An old profile response must never expose another account's records, even for one render.
  return {
    enabled,
    ownerId: enabled ? user.id : undefined,
    queries: Object.fromEntries(resources.map((key, index) => [key, queries[index]])),
    data: Object.fromEntries(
      resources.map((key, index) => [key, enabled ? queries[index].data : undefined]),
    ),
  };
}
